export class CharacterizeTestedPartyDescriptionErrorResponse {
  description: any;
}
